const NS = 'MyAccountUpdateProfilePage';
const CLS = 'myAccountUpdateProfilePage';

export class MyAccountUpdateProfilePage {
	constructor(element) {
		this.element = element;
		this.$element = $(this.element);
		this.$scroller = $('.tpl-scroller');
		this.countryAPI = this.$element.data('countryApi');
		this.registerAPI = this.$element.data('registerApi');
		this.$errorMessagesServerSide = this.$element.find('.error-messages--serverSide');
		this.$sucessMessages = this.$element.find('.success-messages');
		this.countries = [];
		this.$form = $(`#${CLS}-form`);
		this.$formValidate;
		if (this.countryAPI) {
			this.loadCountries();
		}
		this.buildForm();
		this.selectEvents();
		this.resetForm();
	}



	loadCountries() {
		$.ajax({
			type: 'GET',
			url: this.countryAPI,
			headers: {
				'X-IDS-SiteTypeId': this.siteTypeId
			},
			success: (data) => {
				this.countries = data;

				let $countrySelect = this.$element.find('select.country');
				$countrySelect.append(() => {
					let markup = '';
					this.countries.forEach((country) => {
						markup += `<option value="${country.Name}">${country.Name}</option>`;
					});
					return markup;
				});

				setTimeout(() => {
					$countrySelect.selectpicker('refresh');
					$countrySelect.selectpicker('render');
					this.resetForm(); // When countries is changed it sets it ot is-valid, reset said form to prevent this
				}, 100);
			},
			error: () => {
				console.error(`${NS}::Error`, 'Could not load the list of countries');
			}
		});
	}

	scrollToElement(element, offset = 0) {
		return scrollTo(this.$scroller[0], { top: $(element).position().top + offset, duration: 500, easing: 'ease-in-out' });
	}

	selectEvents() {
		this.$element.find('select').on('change', (event) => {
			$(event.currentTarget).blur().focus();
		});

		let formGroupElements = {
			woolmarkContactTypeLicence: this.$element.find('.woolmarkContactTypeLicence'),
			woolmarkContactTypeOther: this.$element.find('.woolmarkContactTypeOther'),
		};

		// Deals with on change for education level
		this.$element.find('select.woolmarkContactType').on('change', (event) => {
			if(this.$element.find('select.woolmarkContactType').val() === 'Other') {
				formGroupElements.woolmarkContactTypeOther.show();
			}
			else{
				formGroupElements.woolmarkContactTypeOther.hide();
			}
			if(this.$element.find('select.woolmarkContactType').val() === 'Woolmark Licensee') {
				formGroupElements.woolmarkContactTypeLicence.show();
			}
			else{
				formGroupElements.woolmarkContactTypeLicence.hide();
			}
		});

		// Deals with change for area of study
		this.$element.find('select.areaStudy').on('change', (event) => {
			if($(event.currentTarget).val() === 'Other') {
				formGroupElements.areaStudyOther.show();
			}
			else {
				formGroupElements.areaStudyOther.hide().find('#AreaStudyOther').val('').removeClass('is-valid is-invalid');
			}
		});
	}

	handleServerSideError(message) {
		this.$errorMessagesServerSide.addClass('is-active').text(message);
	}

	resetForm() {
		this.$form.removeClass('is-submitted');
		this.$formValidate.resetForm();
	}
	
	/**
	 * Implements the form and form validation using jQuery validation: https://jqueryvalidation.org/
	 */
	buildForm() {
		$.validator.addMethod('password', (value, _element) => {
			return new RegExp(this.regexPassword).test(value);
		}, `Please enter a password that contains 8–20 characters, at least one capital letter, one number, and one special character [- ! @ # $ % ^ & * ( ) _ +].`);

		$(`select.slctpckr`).each((_index, element) => {
			// Enable default selected value by passing the data-value in the select
			let $element = $(element);
			let value = $element.attr('data-value');
			$element.selectpicker();
	
			if(!_.isNil(value)) {
				$element.selectpicker('val', value);
				$element.selectpicker('refresh');
			}
	
			// Update value attr
			$element.on('changed.bs.select', () => {
				let value = $element.selectpicker().val();
				$element.attr('data-value', value);
	
				// if language selector, redirect to link
				if ($element.hasClass('siteLanguageWidget-languageSelect')) {
					window.location = value;
				}
			});
	
			$element.on('refreshed.bs.select', () => {
				value = $element.attr('data-value');
	
				if(!_.isNil(value)) {
					$element.selectpicker('val', value);
				}
			});
		});
		
		this.$formValidate = this.$form.validate({
			submitHandler: (form, event) => {
				this.$errorMessagesServerSide.removeClass('is-active').text('');
				$(event.currentTarget).addClass('is-submitted');
				event.preventDefault();

				var array = $(form).serializeArray()
				var formData = {};
				$.map(array, function (n, i) {
					formData[n['name']] = n['value'];
				});

				// Removes empty field values
				_.forOwn(formData, (value, key) => {
					if(_.isNil(value) || value.trim() === '') {
						delete formData[key];
					}
				});

				var json_text = JSON.stringify(formData); 

				let request = new Request(this.registerAPI, {
					method: 'POST',
					body: json_text,
					headers: {
						'Content-Type': 'application/json'
					}
				});

				//this.fullScreenLoaderService.create();

				// submit form data using fetch api
				fetch(request)
					.then((response) => {
						if(response.status === 200) {
							this.$sucessMessages.show();
						}
						else {
							this.handleServerSideError(response.statusText);
						}
						//this.fullScreenLoaderService.destroy();
					})
					.catch((error) => {
						// errors (failed call)
						this.handleServerSideError(error);
						//this.fullScreenLoaderService.destroy();
					});
			},
			invalidHandler: (event, validator) => {
				$(event.currentTarget).addClass('is-submitted');
				if(validator.errorList[0]) {
					let element = validator.errorList[0].element;
					// Caveat for custom-control (radio + checkbox) as the element itself is absolutely positioned.
					// Scroll to the parent element of it instead.
					if($(element).parent('.custom-control') && $(element).parent('.custom-control').length > 0) {
						this.scrollToElement($(element).parent('.custom-control')[0], -60);
					}
					// Second caveat for custom bootstrap select (generated) content
					// Also scroll to the parent element of the select instead
					else if($(element).parent('.bootstrap-select') && $(element).parent('.bootstrap-select').length > 0) {
						this.scrollToElement($(element).parent('.bootstrap-select')[0], -60);
					}
					else {
						this.scrollToElement(element, -60);
					}
				}
			},
			ignore: [],
			rules: {
				Salutation: {
					required: true
				},
				FirstName: {
					required: true
				},
				LastName: {
					required: true
				},
				Email: {
					required: true,
					email: true
				},
				Country: {
					required: true
				},
				EducationLevel: {
					required: true
				},
				OverMinimumAge: {
					required: true
				},
				TermsAndConditions: {
					required: true
				}
			},
			messages: {
				Salutation: {
					required: 'Please select a title.'
				},
				FirstName: {
					required: 'Please enter a first name.'
				},
				LastName: {
					required: 'Please enter a last name.'
				},
				Email: {
					required: 'Please enter an email address.',
					email: 'Please enter a valid email address.'
				},
				Country: {
					required: 'Please select a country.'
				},
				TermsAndConditions: {
					required: 'Please agree to the terms and conditions.'
				}
			},
			errorClass: 'error-messages is-active mt-1',
			errorElement: 'span',
			errorPlacement: (error, element) => {
				if($(element).is('select')) {
					$(element).parents('.bootstrap-select').after(error);
				}
				else {
					error.insertAfter(element);
				}
			},
			highlight: (element) => {
				$(element).addClass('is-invalid').removeClass('is-valid');
			},
			unhighlight: (element) => {
				$(element).addClass('is-valid').removeClass('is-invalid');
			}
		});
	}
}